<template>
<div>
    <List></List>
</div>
</template>
<script>
/* eslint-disable */
import AppMixin from '../../mixins/AppMixin'
import Api from '../../router/api'
import List from '../common/todo/List.vue'

export default {
  name: 'Todo',
  mixins: [AppMixin],
  data () {
    return {}
  },
  components: {
    List
  },
  methods: {},
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

</style>



// WEBPACK FOOTER //
// src/components/employee/Todo.vue